import { render, staticRenderFns } from "./ShowShare.vue?vue&type=template&id=23730469&scoped=true&"
import script from "./ShowShare.vue?vue&type=script&lang=js&"
export * from "./ShowShare.vue?vue&type=script&lang=js&"
import style0 from "./ShowShare.vue?vue&type=style&index=0&id=23730469&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23730469",
  null
  
)

export default component.exports